import * as React from "react";
import { GettingStarted as ConnectedGettingStarted } from "./getting-started";

export const GettingStarted = () => {
  return <ConnectedGettingStarted />;
};
